import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import API_BASE_URL from "../API/API_BASE_URL";

// ✅ Async thunk to fetch questions by visa type
export const getVisaEligibilityQuestions = createAsyncThunk(
  "visaEligibility/getVisaEligibilityQuestions",
  async (visaType, thunkAPI) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/eligibility-questions/${visaType}`
      );
      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || "Error fetching questions");
    }
  }
);

const visaEligibilitySlice = createSlice({
  name: "visaEligibility",
  initialState: {
    questions: [],
    answers: {},
    currentStep: 1,
    loading: false,
    selectedVisaType: "",
  },
  reducers: {
    resetVisaEligibility: (state) => {
      state.questions = [];
      state.answers = {};
      state.currentStep = 1;
      state.selectedVisaType = "";
    },
    saveVisaAnswer: (state, action) => {
      const { order, answer } = action.payload;
      state.answers[order] = answer;
    },
    goToNextVisaStep: (state) => {
      state.currentStep += 1;
    },
    goToPrevVisaStep: (state) => {
      state.currentStep = Math.max(state.currentStep - 1, 1);
    },
    goToVisaStep: (state, action) => {
      state.currentStep = action.payload;
    },
    setSelectedVisaType: (state, action) => {
      state.selectedVisaType = action.payload;
    },
    addQuestion: (state, action) => {
      const newQ = action.payload;
      if (!state.questions.find((q) => q.id === newQ.id)) {
        state.questions.push(newQ);
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getVisaEligibilityQuestions.pending, (state) => {
        state.loading = true;
      })
      .addCase(getVisaEligibilityQuestions.fulfilled, (state, action) => {
  const payload = action.payload;
  if (Array.isArray(payload)) {
    state.questions = payload.filter(Boolean);
  } else if (payload) {
    state.questions = [payload];
  } else {
    state.questions = [];
  }
  state.loading = false;
})

      .addCase(getVisaEligibilityQuestions.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const {
  resetVisaEligibility,
  saveVisaAnswer,
  goToNextVisaStep,
  goToPrevVisaStep,
  goToVisaStep,
  setSelectedVisaType,
  addQuestion,
} = visaEligibilitySlice.actions;

export default visaEligibilitySlice.reducer;

// ✅ make sure the thunk is exported too

